export enum SectionType {
    IndexSerie=1,
    Unity=2,
    Questionarie=3
}